import { render, staticRenderFns } from "./FullNameTitle.vue?vue&type=template&id=3ae0baec&scoped=true"
import script from "./FullNameTitle.vue?vue&type=script&lang=js"
export * from "./FullNameTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae0baec",
  null
  
)

export default component.exports